import { openDB, type IDBPDatabase } from "idb";

const DB_NAME = "oculera-fs-handles";
const STORE_NAME = "handles";
const HANDLE_KEY = "vfa-autosave-dir";
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDb(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      },
    });
    dbPromise.catch(() => {
      dbPromise = null;
    });
  }
  return dbPromise;
}

export async function saveDirHandle(handle: FileSystemDirectoryHandle): Promise<void> {
  const db = await getDb();
  await db.put(STORE_NAME, handle, HANDLE_KEY);
}

export async function loadDirHandle(): Promise<FileSystemDirectoryHandle | null> {
  const db = await getDb();
  const handle = (await db.get(STORE_NAME, HANDLE_KEY)) as FileSystemDirectoryHandle | undefined;
  return handle ?? null;
}

export async function clearDirHandle(): Promise<void> {
  const db = await getDb();
  await db.delete(STORE_NAME, HANDLE_KEY);
}
